/* eslint-disable */

import React from "react";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import APIClient from "../client";
import {
  Button,
  OverlayTrigger,
  Popover,
  Spinner,
  Tabs,
  Tab,
  DropdownButton,
  Dropdown,
  Form,
  Row,
  Col,
} from "react-bootstrap";
import Jobs from "./Jobs";

import cropr from "../../shared/utils/cropr";
import gettext from "../../shared/utils/gettext";
import { interpolate } from "../../shared/utils/legacy";
import Tractors from "./Tractors";

class LinkAGCO extends React.Component {
  state = {
    showModal: false,
    account: null,
    agcoUsername: "",
    agcoPassword: "",
    agcoPreserve: false,
  };

  constructor(props, context) {
    super(props, context);
    this.loadAccount();
  }

  loadAccount = () => {
    fetch("/apps/cloudfarm/get_tractors/A/")
      .then((response) => {
        if (response.status === 401) {
          cropr.notify(
            "danger",
            interpolate(gettext("Your %s authorization seems to be no longer valid."), ["AGCO"])
          );
        }
        if (response.ok) {
          response.json().then((account) => {
            this.setState({
              account: account,
            });
          });
        } else {
          throw { status: response.status };
        }
      })
      .catch((error) => {
        this.setState({
          account: null,
        });
      });
  };

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.id;
    this.setState({
      [name]: value,
    });
  };

  async updatePreserve(event) {
    const formData = new FormData();
    let checked = event.target.checked;
    formData.append("agco_preserve", checked);
    try {
      await APIClient.post(
        "/api/data/users/save_agco_credentials/",
        { formData: formData },
        cropr.cloudfarm_oauth_token
      ).then((response) => {
        cropr.notify("success", gettext("Done"));
        const account = this.state.account;
        account.agco_preserve = checked;
        this.setState({ account: account });
      });
    } catch {
      cropr.notify("danger", gettext("Could not update settings."));
    }
  }

  async saveAccount() {
    const formData = new FormData();
    formData.append("agco_username", this.state.agcoUsername);
    formData.append("agco_password", this.state.agcoPassword);
    formData.append("agco_preserve", this.state.agcoPreserve);
    try {
      await APIClient.post(
        "/api/data/users/save_agco_credentials/",
        { formData: formData },
        cropr.cloudfarm_oauth_token
      ).then((response) => {
        cropr.notify("success", gettext("Your account has been linked successfully."));
        this.loadAccount();
      });
    } catch {
      cropr.notify("danger", gettext("Could not connect with the provided credentials."));
    }
  }

  async removeAccount() {
    try {
      await APIClient.remove(
        "/api/data/users/delete_agco_credentials/",
        null,
        cropr.cloudfarm_oauth_token
      ).then((response) => {
        cropr.notify("success", gettext("Your account has been deleted successfully."));
        this.loadAccount();
      });
    } catch {
      cropr.notify("danger", gettext("Your account could not be deleted at this time."));
    }
  }

  toggle(show) {
    this.setState({ showModal: show });
  }

  render() {
    return (
      <>
        <a href="#" className="dropdown-item" onClick={() => this.toggle(true)}>
          {gettext("Connect with AGCO")}
        </a>
        <Modal show={this.state.showModal} onHide={() => this.toggle(false)}>
          <Modal.Header closeButton>
            <Modal.Title style={{ width: "100%" }}>
              AGCO VarioDoc/TaskDoc account{" "}
              <img
                className="float-right"
                src="/static/images/wizard/logo-agco.png"
                alt="AGCO"
                style={{ height: "32px" }}
              />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Tabs defaultActiveKey={this.state.account ? "tractors" : "account"}>
              <Tab eventKey="account" title={gettext("Account")}>
                {this.state.account ? (
                  <div>
                    <h4 className="mt-2">
                      {gettext("Currently linked account")}:&nbsp;
                      {this.state.account.agco_username}
                    </h4>
                    <div className="mt-2">
                      <Form.Group as={Row} controlId="agcoPreserve">
                        <Col sm={{ span: 10, offset: 0 }}>
                          <Form.Check
                            label={gettext("Preserve files at server")}
                            checked={this.state.account.agco_preserve}
                            onChange={(e) => this.updatePreserve(e)}
                          />
                        </Col>
                      </Form.Group>
                    </div>
                    <div className="mt-4">
                      <a className="btn btn-warning mr-1" onClick={() => this.removeAccount()}>
                        {gettext("Delete")}
                      </a>
                    </div>
                  </div>
                ) : (
                  <div className="mt-2">
                    <Form onSubmit={() => this.saveAccount()}>
                      <Form.Group as={Row} controlId="agcoUsername">
                        <Form.Label column sm={2}>
                          {gettext("Username")}
                        </Form.Label>
                        <Col sm={10}>
                          <Form.Control
                            type="email"
                            autoComplete="new-password"
                            placeholder={gettext("Username")}
                            value={this.state.agcoUsername}
                            onChange={this.handleInputChange}
                          />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} controlId="agcoPassword">
                        <Form.Label column sm={2}>
                          {gettext("Password")}
                        </Form.Label>
                        <Col sm={10}>
                          <Form.Control
                            autoComplete="new-password"
                            type="password"
                            placeholder="Password"
                            value={this.state.agcoPassword}
                            onChange={this.handleInputChange}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} controlId="agcoPreserve">
                        <Col sm={{ span: 10, offset: 2 }}>
                          <Form.Check
                            label={gettext("Preserve files at server")}
                            checked={this.state.agcoPreserve}
                            onChange={this.handleInputChange}
                          />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row}>
                        <Col sm={{ span: 10, offset: 2 }}>
                          <Button type="submit">{gettext("Save")}</Button>
                        </Col>
                      </Form.Group>
                    </Form>
                  </div>
                )}
              </Tab>
              <Tab eventKey="tractors" title={gettext("Tractors")} disabled={!this.state.account}>
                {this.state.account ? (
                  <Tractors
                    accountName={this.state.account.agco_username}
                    headers={[gettext("Name"), gettext("Active"), gettext("Last seen")]}
                    tractors={this.state.account.tractors.map((t, i) => ({
                      display: [
                        cropr.getDeviceName(t.tractor_id),
                        t.active ? gettext("Yes") : gettext("No"),
                        t.timestamp_last_seen ? moment(t.timestamp_last_seen).format("LLLL") : "-",
                      ],
                      serialNr: t.tractor_id,
                      receiveOnly: false,
                    }))}
                  />
                ) : null}
              </Tab>
              <Tab eventKey="tasks" title={gettext("Tasks")} disabled={!this.state.account}>
                {this.state.account ? <Jobs online_service="A" /> : null}
              </Tab>
              <Tab eventKey="help" title={gettext("Help")}>
                <h5 className="mt-2">{gettext("What is a connection to AGCO?")}</h5>
                {gettext(
                  "If you possess a tractor of a brand manufactured bij AGCO " +
                    "(Fendt, Massey Ferguson or Valtra), which is equiped with a wireless connection to the Variodoc/ Taskdoc platform, " +
                    "you can use your credentials to connect Cloudfarm to these tractors. Please talk to your dealer for more information about this system."
                )}
                <h5 className="mt-2">{gettext("How can I enable it?")}</h5>
                {gettext(
                  "Create an FMIS-group in your AGCO account and add your vehicles to it. You can use your username for FMIS Data Transfer and the Data Exchange Password to create a link with Cloudfarm."
                )}
                <h5 className="mt-2">{gettext("What can I do with it?")}</h5>
                {gettext(
                  "You can exchange task data directly between your vehicle and The Dacom platform/ Cloudfarm:"
                )}
                <ul>
                  <li>
                    {gettext(
                      'After connecting, your vehicle(s) will be present under the "Machines" menu. There, you can rename your vehicle, and attach a default recording template.'
                    )}
                    &nbsp;
                    <strong>
                      {gettext(
                        "Please note: the serial number is used to identify your vehicle at the online service. Please don't change it."
                      )}
                    </strong>
                  </li>
                  <li>
                    {gettext(
                      'You can can send the base data for your farm to each vehicle, using the buttons in the "Tractors" tab in this dialog. The base data includes field boundaries, way lines and the products in your stock.'
                    )}
                  </li>
                  <li>
                    {gettext(
                      'You can can create plannings for your work in the "Recording" menu. If you select a connected vehicle under "Machines", the planning will be automatically transmitted to your vehicle, including the relevant field boundary, way lines and even a prescription map if you created one.'
                    )}
                  </li>
                  <li>
                    {gettext(
                      'After completing a task on the vehicle, the "as applied" data is automatically loaded in Cloudfarm, where you can review the work done.'
                    )}
                  </li>
                  <li>
                    {gettext(
                      'If you complete a task for a planning you created beforehand, this planning will automatically be marked "performed", and enriched with data from the task. Alternatively, if no planning was made, a concept recording will be created so you can conveniently convert this into a full recording.'
                    )}
                  </li>
                  <li>
                    {gettext(
                      ' If you use the vehicle to record field boundaries and way lines, you can easily import them into your Dacom farm by clicking "details" in the dataset card and go to the "geometry" tab. This way you can easily reuse this data for other vehicles, for instance by converting them into a different format with the "export machine data" functionality. '
                    )}
                  </li>
                </ul>
              </Tab>
            </Tabs>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default LinkAGCO;
